import React, { useState, useRef, useEffect } from 'react';
import './calendrier-carte.css';
import useApi from "../../hooks/useApi";
import SVG from "react-inlinesvg";

interface Carte {
  keyName: string;
  keyValue: string;
}

function cap(value: number, min: number, max: number) {
  if (value < min) return min;

  if (value > max) return max;

  return value;
}

function Zoomer(props: any) {
  return (
    <div className="zoomer">
      <div className="zoomer-button plus" onClick={props.onPlusClick || (() => { })}>
        +
      </div>
      <div className="zoomer-button minus" onClick={props.onMinusClick || (() => { })}>
        -
      </div>
    </div>
  );
}

function CalendrierCarte(props: any) {
  const { data: carte, getData: getCarte } = useApi<Carte>();
  const transparentImg = new Image(0, 0);
  const [state, setState] = useState({
    offsetX: 0,
    offsetY: 0,
    dragMouseX: 0,
    dragMouseY: 0,
    zoom: 1,
    isDragging: false
  });

  // const mapWrapper = useRef(null);
  const mapWrapper = useRef<HTMLDivElement | null>(null);
  // const mapWrapper = useRef<any>();

  //console.log(carte)
  useEffect(() => {
    getCarte({customPath:`Configuration/SVG_DATA`
  });
    // getUnites(`typeunitegroupe/7f136e46-34e4-ed11-b474-82c5f260a79d/unite`);
    // setSeoTitle(this.props.entrepriseName, "Réservation", `Carte des ${descriptionHebergement[this.props.getTypeHebergement()]}`);
    // transparentImg = new Image(0, 0);
    transparentImg.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    //this.mapRef.addEventListener("touchstart", this.onMapTouchMove, {passive: true});
  }, [])

  const initUnitesPathsOnMap = () => {
    // this.removeCurrentUnites();
    // this.saveNewUnitesOriginalStyles();
    // this.drawNewUnites();
  }

  const updateMap = (newClientX: number, newClientY: number, newZoom: number) => {
    const mapWrap = mapWrapper.current;
    if (mapWrapper === undefined || !mapWrap)
      return;

    const zoom = cap(newZoom, 1, 5);

    const minLeft = (mapWrap.offsetWidth / zoom - mapWrap.offsetWidth) / 2;
    const maxLeft = (mapWrap.offsetWidth - mapWrap.offsetWidth / zoom) / 2;
    const minTop = (mapWrap.offsetHeight / zoom - mapWrap.offsetHeight) / 2;
    const maxTop = (mapWrap.offsetHeight - mapWrap.offsetHeight / zoom) / 2;

    const left = cap(state.offsetX - state.dragMouseX + newClientX, minLeft, maxLeft);
    const top = cap(state.offsetY - state.dragMouseY + newClientY, minTop, maxTop);

    const isDragEnd = state.isDragging && newClientX === 0 && newClientY === 0;

    if (!isDragEnd) {
      setState({
        offsetX: left,
        offsetY: top,
        dragMouseX: newClientX,
        dragMouseY: newClientY,
        zoom: zoom,
        isDragging: isDragEnd
      });
    }
  }

  const onMapImageLoad = () => {
    initUnitesPathsOnMap();
    // setState({
    //   mapLoaded: true
    // });
  }

  const onMapDrag = (e: any) => {
    updateMap(e.clientX, e.clientY, state.zoom);
  }

  const onMapDragStart = (e: any) => {
    e.dataTransfer.setDragImage(transparentImg, 0, 0);

    setState({
      ...state,
      dragMouseX: e.clientX,
      dragMouseY: e.clientY,
      isDragging: true
    });
  }

  const onMapDragEnd = (e: any) => {
    setState({
      ...state,
      isDragging: false
    });
  }

  const onPlusClick = () => {
    updateMap(state.dragMouseX, state.dragMouseY, state.zoom * 1.2);
  }

  const onMinusClick = () => {
    updateMap(state.dragMouseX, state.dragMouseY, state.zoom / 1.2);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div id="choix-unite-carte">
        <Zoomer onPlusClick={onPlusClick} onMinusClick={onMinusClick} />
        <div
          ref={mapWrapper}
          // ref={(e) => (mapWrapper = e)}
          style={{
            transform: "scale(" + state.zoom + ") translate(" + state.offsetX + "px, " + state.offsetY + "px)",
            transition: state.isDragging ? "initial" : "transform 0.3s ease-out 0s"
          }}
          onDragStart={onMapDragStart}
          onDrag={onMapDrag}
          onDragEnd={onMapDragEnd}
          // onTouchStart={this.onMapTouchStart}
          // onTouchMove={this.onMapTouchMove}
          // onTouchEnd={this.onMapTouchEnd}
          // onTouchCancel={this.onMapTouchCancel}
          draggable={true}
        >
          {/* {!props.unites || props.unites.length <= 0 &&
            <div style={{ position: "absolute", margin: 0, zIndex: 999, height: "100%", width: "100%", backgroundColor: "#00000055" }} id="aucune-unite-wrapper">
              <img style={{ height: "100%", filter: "brightness(0) saturate(100%) invert(90%) sepia(1%) saturate(20%) hue-rotate(290deg) brightness(104%) contrast(100%)" }}
                src={require("../../images/loading.svg")}
                alt="chargement" />)
            </div>
          } */}
          {carte?.keyValue &&
            <SVG src={carte.keyValue} onLoad={onMapImageLoad} />}
        </div>
      </div>
    </div>
  );
}

export default CalendrierCarte;